import { axs } from './config/axiosConfig';
import { BASE_API_URL } from 'lib/setting';

const basePath = `${BASE_API_URL}/patient`;

// projectCode
export function deleteProject({ projectCode }: { projectCode: string }) {
  return axs({ url: `${basePath}/${projectCode}`, method: 'delete' });
}

export function editTimeline(payload: { projectCode: string; stage: number }) {
  return axs({ url: `${basePath}/timeline`, method: 'put', data: payload });
}

// ?page=1&keyword&stages=0%6&startDate&endDate
export function fetchReworkProjects(payload: {
  page: number;
  keyword: string;
  stages: string;
  startDate?: number;
  endDate?: number;
}) {
  return axs({ url: `${basePath}/rework`, method: 'get', params: payload });
}

export function newPatient(payload: {
  chartNumber: string;
  firstName: string;
  lastName: string;
  birthday: string;
  gender: 'M' | 'F' | 'N';
  comment: string;
  identification: string;
}) {
  console.log('editPatient API call ___');
  // return;
  return axs({ url: `${basePath}`, method: 'post', data: payload });
}

export function fetchProjectPatients(payload: { page: number }) {
  return axs({ url: `${basePath}/project`, method: 'get', params: payload });
}

export function fetchPatientList(payload: {
  page: string;
  keyword: string;
  lastNameInitial: string;
  stages: string;
  startDate: Date;
  endDate: Date;
}) {
  console.log('fetchPatientList API call ___');
  // return;
  return axs({ url: `${basePath}`, method: 'get', params: payload });
}

export function fetchPatient(patientCode: string) {
  // const { patientCode } = payload;
  console.log('fetchPatient API call ___', patientCode);
  // return axs({ url: `${basePath}`, method: 'get', params: payload });
  return axs({ url: `${basePath}/${patientCode}`, method: 'get' });
}

// export function editPatient(payload: { patientCode: string; stage: number }) {
//   return axs({ url: `${basePath}/timeline`, method: 'put', data: payload });
// }
export function editPatient({
  patientCode,
  data,
}: {
  patientCode: string;
  data: {
    chartNumber: string;
    firstName: string;
    lastName: string;
    birthday: string;
    gender: 'M' | 'F' | 'N';
    comment: string;
    identification: string;
  };
}) {
  return axs({ url: `${basePath}/${patientCode}`, method: 'put', data: data });
}

export function deletePatient({
  patientCode,
  data,
}: {
  patientCode: string;
  data: {
    password: string;
    provider: string;
  };
}) {
  return axs({ url: `${basePath}/${patientCode}`, method: 'delete', data: data });
}

export function checkChartNumber(payload: { chartNumber: string }) {
  return axs({ url: `${basePath}/chartnumber`, method: 'get', params: payload });
}
